import { Agents } from "@/queries/agent-queries";

export function useAgentId() {
    return Agents.InEnvironmentOna.id;
}
